import React, { useContext, useEffect, useState } from "react";

import { TableCell, TableRow } from "@mui/material";
import { Skeleton } from '@mui/material';

import Context from "../context-index";
import { RowActions, RowActionsExtra } from "../export";

type Props = {
  pageSize: number;
  length: number;
  rowActions: RowActions | undefined;
  rowActionsExtra?: RowActionsExtra[];
  positionActions: "left" | "right";
  showSelection: boolean;
};

const HEIGHT_SKELETON = "25px";
const WIDTH_SKELETON = "85%";

const GridBodyLoading = (props: Props) => {
  const { showSelection, rowActions, rowActionsExtra, positionActions, pageSize, length } = props;

  const { selectedColumns } = useContext(Context);

  const [virtualData, setVirtualData] = useState<number[]>();

  useEffect(() => {
    generateVirtualData();
  }, [pageSize]);

  const generateVirtualData = () => {
    const virtualData: number[] = [];

    for (let index = 0; index < pageSize; index++) {
      virtualData.push(index);
    }
    setVirtualData(virtualData);
  };

  const renderCheckboxSkeleton = () => {
    if (showSelection && selectedColumns.length >= 1) {
      return (
        <TableCell style={{ padding: "0 15px" }}>
          <Skeleton width={WIDTH_SKELETON} height={HEIGHT_SKELETON} />
        </TableCell>
      );
    }
  };

  const renderActionsSkeleton = () => {
    if (
      (positionActions === "left" || positionActions === "right") &&
      (rowActions || rowActionsExtra) &&
      selectedColumns.length >= 1
    ) {
      return (
        <TableCell>
          <Skeleton width={WIDTH_SKELETON} height={HEIGHT_SKELETON} />
        </TableCell>
      );
    }
  };

  const renderColumns = () => {
    if (selectedColumns && selectedColumns?.length > 0) {
      return selectedColumns?.map((value, index) => {
        return (
          <TableCell key={index}>
            <Skeleton width={WIDTH_SKELETON} height={HEIGHT_SKELETON} />
          </TableCell>
        );
      });
    }

    return null;
  };

  const renderContent = () => {
    if (virtualData && virtualData?.length > 0) {
      return virtualData?.map((value) => {
        return (
          <TableRow
            key={value}
            style={{
              backgroundColor: value % 2 === 1 || length === 1 ? "transparent" : "#f2f4f7",
            }}
          >
            {renderCheckboxSkeleton()}
            {renderActionsSkeleton()}
            {renderColumns()}
          </TableRow>
        );
      });
    }

    return null;
  };

  return <>{renderContent()}</>;
};

export default GridBodyLoading;
